<template lang="html">

  <div class="politica-de-cookies">

    <section class="intro-legales column-center launch">

      <h1 class="subtitle-intro">
        <span>{{$t("intros_legales.politica_cookies")}}</span>
      </h1>

    </section> 

    <section class="textos-legales container">

     <h2>¿Qué son las cookies y para qué las usamos?</h2>
     <p>Una cookie o galleta informática es un pequeño archivo de información que se guarda en su navegador cada vez que visita nuestra página web. </p>
     <p>La utilidad de las cookies es guardar el historial de su actividad en nuestra página web, de manera que, cuando la visite nuevamente, ésta pueda identificarle y configurar el contenido de la misma en base a sus hábitos de navegación, identidad y preferencias.</p>
     <p>Una cookie es inofensiva, no contiene código malicioso o malintencionado (ej. virus, troyanos, gusanos, etc.) que pueda dañar su terminal (ordenador, smartphone, tableta, etc.), pero sí tiene cierto impacto sobre su derecho a la protección de sus datos, pues recoge determinada información concerniente a su persona (hábitos de navegación, identidad, preferencias, etc.).</p>

     <h2>¿Qué información guarda una cookie?</h2>
     <p>Las cookies no suelen recoger categorías especiales de datos personales (datos sensibles). Los datos que guardan son de carácter técnico, preferencias personales, personalización de contenidos, etc.</p>

     <h2>¿Qué tipo de cookies existen?</h2>
     <p>Con carácter general, existen cinco tipos de cookies:</p>
     <p>Cookies técnicas:</p>
     <p>Son las cookies más básicas. Permiten al usuario la navegación a través de una página web, plataforma o aplicación y la utilización de las diferentes opciones o servicios que en ella existan como, por ejemplo, controlar el tráfico y la comunicación de datos, identificar la sesión, acceder a partes de acceso restringido, recordar los elementos que integran un pedido, realizar el proceso de compra de un pedido, realizar la solicitud de inscripción o participación en un evento, utilizar elementos de seguridad durante la navegación, almacenar contenidos para la difusión de videos o sonido o compartir contenidos a través de redes sociales.</p> 

     <h2>Cookies de personalización: </h2>
     <p>Son aquéllas que permiten al usuario acceder al servicio con algunas características de carácter general predefinidas en función de una serie de criterios en el terminal del usuario como por ejemplo serian el idioma, el tipo de navegador a través del cual accede al servicio, la configuración regional desde donde accede al servicio, etc.</p>

     <h2>Cookies de análisis:</h2>

     <h2>Cookies publicitarias:</h2>
     <p>Son aquéllas que permiten la gestión, de la forma más eficaz posible, de los espacios publicitarios que, en su caso, el responsable haya incluido en una página web, aplicación o plataforma desde la que presta el servicio solicitado en base a criterios como el contenido editado o la frecuencia en la que se muestran los anuncios.</p>

     <h2>Cookies de publicidad comportamental: </h2>
     <p>Son aquéllas que permiten la gestión, de la forma más eficaz posible, de los espacios publicitarios que, en su caso, el responsable haya incluido en una página web, aplicación o plataforma desde la que presta el servicio solicitado. Estas cookies almacenan información del comportamiento de los usuarios obtenida a través de la observación continuada de sus hábitos de navegación, lo que permite desarrollar un perfil específico para mostrar publicidad en función del mismo.</p>

     <h2>¿Qué son las cookies propias y las de terceros?</h2>
     <p>Cookies de propias: </p>
     <p>Las cookies propias son aquellas que se generan y gestionan por el propio responsable que presta el servicio solicitado por el usuario.</p>

     <h2>Cookies de terceros: </strong></h2>
     <p>Son aquellas que se generan por otras entidades distintas al propio responsable (servicios o proveedores externos, como por ejemplo Google).</p>

     <h2>¿Qué tipo de cookies guarda nuestra página web?</h2>
    <p>A continuación, procedemos a relacionar el tipo de cookies que guarda nuestra página web y la finalidad de las mismas:</p>
    <p>- Tipo de cookie</p>
    <p>Cookies de terceros, de análisis: Google Analytics</p>
    <p>- Finalidad</p>
    <p>Seguimiento y análisis del comportamiento de los usuarios en la página web. La información recogida mediante este tipo de cookies se utiliza en la medición de la actividad de los sitios web, para la elaboración de perfiles de navegación de los usuarios de dichos sitios, aplicaciones y plataformas, con el fin de introducir mejoras en función del análisis de los datos de uso que hacen los usuarios del servicio.</p>
    <p>- Cuándo y cómo se guarda</p>
    <p>La cookie registra la actividad del usuario en el tiempo real de su navegación y los datos se almacenan en la aplicación ‘Google Analytics’.</p>


    <h2>¿Qué puedo hacer con las cookies?</h2>
    <p>Las cookies pueden ser borradas, aceptadas o bloqueadas, según desee, para esto sólo debe configurar convenientemente el navegador web.</p>
    <p>En cualquier momento, puede impedir la instalación de cookies (bloqueo) en su equipo mediante la opción correspondiente de su navegador, pero en dicho caso no podremos asegurarle el correcto funcionamiento de las distintas funcionalidades de nuestra página web.</p>
    <p>A continuación, le facilitamos los enlaces para la gestión y bloqueo de cookies dependiendo del navegador que utilice:</p>
    <p><strong>Internet Explorer:</strong> <a target="_blank" href="http://windows.microsoft.com/es-xl/internet-explorer/delete-manage-cookies#ie=ie-10">http://windows.microsoft.com/es-xl/internet-explorer/delete-manage-cookies#ie=ie-10</a></p>
    <p><strong>FireFox:</strong> <a target="_blank" href= "http://support.mozilla.org/es/kb/habilitar-y-deshabilitar-cookies-que-los-sitios-we">http://support.mozilla.org/es/kb/habilitar-y-deshabilitar-cookies-que-los-sitios-we</a></p>
    <p><strong>Chrome:</strong> <a target="_blank" href="https://support.google.com/chrome/answer/95647?hl=es">https://support.google.com/chrome/answer/95647?hl=es</a></p>
    <p><strong>Safari:</strong> <a target="_blank" href="https://www.apple.com/legal/privacy/es/cookies/">https://www.apple.com/legal/privacy/es/cookies/</a></p>

    <p>También puede borrar las cookies que tenga guardadas en su navegador acudiendo a las opciones de configuración del mismo.</p>


    </section>

  </div>

</template>

<script lang="js">
  export default  {
    name: 'politica-de-cookies',
  }
</script>




// WEBPACK FOOTER //
// src/components/views/politica-de-cookies.vue